import React, { useEffect, useRef, useState } from 'react'
import style from './NavBar.module.scss';

import Typed from 'typed.js'

import { FaBars, FaTimes, FaUserAlt, FaBriefcase, FaEnvelope } from "react-icons/fa";
import { GiSkills } from "react-icons/gi";
import { MdDesignServices } from "react-icons/md";

import { BiCodeAlt } from 'react-icons/bi'

export default function NavBar({ translation, i18n }) {

    const [clickMobile, setClickMobile] = useState(false)

    const changeClick = () => {
        setClickMobile(false);
    }

    const present = useRef(null)

    useEffect(() => {
        const typed = new Typed(present.current, {
            strings: ["Full Stack", "Front End", "Back End"],
            startDelay: 300,
            typeSpeed: 200,
            backSpeed: 200,
            smartBackspace: true,
            showCursor: false,
            shuffle: false,
            backDelay: 1500,
            loop: true,
            loopCount: false,
            // cursorChar: "|",
        })
    }, [])

    return (
        <>
            <div className={style.container__header}>
                <div className={style.container__header__left}>
                    <h2>{translation("header.hi")}</h2>
                    <h3>
                        {
                            translation("header.developer") === "Desarrollador" && " Desarrollador "
                        }
                        <span ref={present}></span>
                        {
                            translation("header.developer") === "Developer" && " Developer "
                        }
                    </h3>
                    <div className={style.container__header__left__buttons}>
                        <a href="#about" className={style.container__header__left__buttons_about} data-aos={"fade-up"} data-aos-duration={2000}>{translation("header.btn-read-about")}</a>
                        <a href="#portfolio" className={style.container__header__left__buttons_projects} data-aos={"fade-up"} data-aos-duration={3000}>{translation("header.btn-see-projects")}</a>
                    </div>
                </div>
                <div className={style.container__header__right}>
                    <img src='/img/vector.jpg' alt='logo' />
                </div>
            </div>

            <div className={style.container}>
                <div className={style.container__wrapper}>
                    <div className={style.container__wrapper__logo}>
                        <BiCodeAlt />
                        <p>Rodrigo Ribes Dev.</p>
                    </div>

                    <div className={style.container__wrapper__menu} style={{ left: `${clickMobile ? "0" : "-100%"}` }}>
                        <div className={style.container__wrapper__menu__item} onClick={() => changeClick()} >
                            <FaUserAlt />
                            <a href="#about">{translation("navbar.about")}</a>
                        </div>

                        <div className={style.container__wrapper__menu__item} onClick={() => changeClick()}>
                            <MdDesignServices />
                            <a href="#services">{translation("navbar.service")}</a>
                        </div>

                        <div className={style.container__wrapper__menu__item} onClick={() => changeClick()}>
                            <GiSkills />
                            <a href="#skills">{translation("navbar.skills")}</a>
                        </div>

                        <div className={style.container__wrapper__menu__item} onClick={() => changeClick()}>
                            <FaBriefcase />
                            <a href="#portfolio">{translation("navbar.portfolio")}</a>
                        </div>

                        <div className={style.container__wrapper__menu__item} onClick={() => changeClick()}>
                            <FaEnvelope />
                            <a href="#contact">{translation("navbar.contact")}</a>
                        </div>
                    </div>
                    <div className={style.container__wrapper__social} style={{ left: `${clickMobile ? "0" : "-100%"}` }}>
                        <a
                            data-aos="zoom-in"
                            className={style.container__wrapper__social_link} href="https://github.com/rodri-ribes/" target="_blank" rel="noreferrer">
                            <i className="bi bi-github"></i>
                        </a>
                        <a
                            data-aos="zoom-in"
                            className={style.container__wrapper__social_link} href="https://www.linkedin.com/in/rodrigo-ribes/" target="_blank" rel="noreferrer">
                            <i className="bi bi-linkedin"></i>
                        </a>
                        <a
                            data-aos="zoom-in"
                            className={style.container__wrapper__social_link} href={`https://api.whatsapp.com/send?phone=+5492246517581&text=${i18n?.language === "es" ? encodeURI("Hola Rodrigo, ") : encodeURI("Hi Rodrigo, ")}`} target="_blank" rel="noreferrer">
                            <i className="bi bi-whatsapp"></i>
                        </a>
                        <a
                            data-aos="zoom-in"
                            className={style.container__wrapper__social_link} href={`mailto:rodri_ribes@hotmail.com?Subject=${encodeURI("Propuesta desde el Portfolio")}`} target="_blank" rel="noreferrer">
                            <i className="bi bi-envelope"></i>
                        </a>

                    </div>

                    <div className={style.container__wrapper__iconMobile} onClick={() => setClickMobile(!clickMobile)}>
                        {
                            clickMobile ?
                                <FaTimes />
                                :
                                <FaBars />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
